import { defineComponent as _defineComponent } from 'vue'
import DomService from '@/core/dom.service';
import useBreakpoints from '@/core/responsive/breakpoints/breakpoint.mixin';
import { store } from '@/store';
import ProductColorPicker from './ProductColorPicker.vue';
import { PrivatePrioritizedVariantFilterObject, ProductProperty, ProfessionalPrioritizedVariantFilterObject, ProductPropertyData, ProductPropertyOption } from './product-properties';
import ProductPropertyModal from './ProductPropertyModal.vue';
import SizeFlyoverContent from './SizeFlyoverContent.vue';
import { computed, ref, watch } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductPropertySelector',
  props: {
    prioritizedVariantFilter: null,
    colors: null,
    options: null,
    animateChanges: { type: Boolean }
  },
  emits: ["change-filter"],
  setup(__props: any, { emit }: { emit: ({(e: 'change-filter', value: string, property: string): void }), expose: any, slots: any, attrs: any }) {

const props = __props as {
    prioritizedVariantFilter: PrivatePrioritizedVariantFilterObject | ProfessionalPrioritizedVariantFilterObject,
    colors: IColorOption[],
    options: ProductPropertyData[],
    animateChanges?: boolean
}





const product = computed<ProductBaseViewModel<VariantBaseViewObject>>(() => store.getters['catalog/product']);
const selectedVariant = computed<VariantBaseViewObject>(() => store.getters['catalog/selectedVariant']);

const breakpointIsActive = useBreakpoints();

const animateChange = ref<{ [key: string]: boolean }>({});
const variantFilter = ref<PrivatePrioritizedVariantFilterObject | ProfessionalPrioritizedVariantFilterObject>(props.prioritizedVariantFilter);

watch(() => props.prioritizedVariantFilter, onPrioritizedVariantFilterChange, { deep: true });
function onPrioritizedVariantFilterChange() {
    variantFilter.value = props.prioritizedVariantFilter;
}

// MODAL FLYOVER
const isPropertyModalOpen = ref<boolean>(false);
const modalTitle = ref<string>('');
const modalPropertyOptions = ref<ProductPropertyOption[]>([]);
const modalSelectedValue = ref<string>('');
const modalFilter = ref<string>('');

function togglePropertyModal(filter: string, title: string, options: ProductPropertyOption[], selectedValue: string): void {
    isPropertyModalOpen.value = !isPropertyModalOpen.value;
    modalFilter.value = filter;
    modalTitle.value = title;
    modalSelectedValue.value = selectedValue;
    modalPropertyOptions.value = options;
};

function closeModal() {
    isPropertyModalOpen.value = false;
}
// ----

function changeFilter(value: string, property: string) {
    emit('change-filter', value, property);
}

const isLargeBreakpoint = computed<boolean>(() => {
    return breakpointIsActive.value.large;
});

watch(() => isLargeBreakpoint.value, onBreakpointAndOpenStateChange);
watch(() => isPropertyModalOpen.value, onBreakpointAndOpenStateChange);
function onBreakpointAndOpenStateChange() {
    if (isPropertyModalOpen.value && !isLargeBreakpoint.value) {
        DomService.addElementClass('html', 'modal-open');
    } else {
        DomService.removeElementClass('html', 'modal-open');
    }
}

const visibleOptions = computed<ProductPropertyData[]>(() => {
    return props.options.filter(x => x.options.length > 1);
});

watch(() => selectedVariant.value, onSelectedVariantChanged);
function onSelectedVariantChanged(variant: VariantBaseViewObject, oldVariant: VariantBaseViewObject) {
    if (!props.animateChanges) {
        return;
    }
    const isFirstChange = !oldVariant.id;
    if (!isFirstChange) {
        animateAutoChangedFacets(variant, oldVariant);
    }
}

function animateAutoChangedFacets(variant: VariantBaseViewObject, oldVariant: VariantBaseViewObject) {
    animateChange.value = {};
    animateChange[ProductProperty.propertyNameSizeText] = oldVariant.sizeText !== variant.sizeText;
    animateChange[ProductProperty.propertyNameColorCode] = oldVariant.colorCode !== variant.colorCode;
    animateChange[ProductProperty.propertyNameLightsourceText] = oldVariant.lightsourceText !== variant.lightsourceText;
    animateChange[ProductProperty.propertyNameArmText] = oldVariant.armText !== variant.armText;
    animateChange[ProductProperty.propertyNameMountingText] = oldVariant.mountingText !== variant.mountingText;
    animateChange[ProductProperty.propertyNameCableType] = oldVariant.cableType !== variant.cableType;
    animateChange[ProductProperty.propertyNameSwitchPlug] = oldVariant.switchPlug !== variant.switchPlug;
    animateChange[ProductProperty.propertyNameShieldDiffusor] = oldVariant.shieldDiffusor !== variant.shieldDiffusor;
    animateChange[ProductProperty.propertyNameAdditionalFeatures] = oldVariant.additionalFeatures !== variant.additionalFeatures;
    animateChange[ProductProperty.propertyNameBody] = oldVariant.body !== variant.body;
    setTimeout(() => {
        animateChange.value = {};
    }, 1000);
}

const labels = {
    [ProductProperty.propertyNameArmText]: 'Pages.ProductDetail.ProductVariantPicker.Arm',
    [ProductProperty.propertyNameSizeText]: 'Pages.ProductDetail.ProductVariantPicker.Size',
    [ProductProperty.propertyNameLightsourceText]: 'Pages.ProductDetail.ProductVariantPicker.Lightsource',
    [ProductProperty.propertyNameMountingText]: 'Pages.ProductDetail.ProductVariantPicker.MountingType',
    [ProductProperty.propertyNameCableType]: 'Pages.ProductDetail.ProductVariantPicker.CableType',
    [ProductProperty.propertyNameSwitchPlug]: 'Pages.ProductDetail.ProductVariantPicker.SwitchPlug',
    [ProductProperty.propertyNameAdditionalFeatures]: 'Pages.ProductDetail.ProductVariantPicker.AdditionalFeatures',
    [ProductProperty.propertyNameShieldDiffusor]: 'Pages.ProductDetail.ProductVariantPicker.ShieldDiffusor',
    [ProductProperty.propertyNameBody]: 'Pages.ProductDetail.ProductVariantPicker.Body'
};

function getLabelName(data: ProductPropertyData): string {
    return labels[data.property];
}


return { __sfc: true,props, emit, product, selectedVariant, breakpointIsActive, animateChange, variantFilter, onPrioritizedVariantFilterChange, isPropertyModalOpen, modalTitle, modalPropertyOptions, modalSelectedValue, modalFilter, togglePropertyModal, closeModal, changeFilter, isLargeBreakpoint, onBreakpointAndOpenStateChange, visibleOptions, onSelectedVariantChanged, animateAutoChangedFacets, labels, getLabelName, ProductColorPicker, ProductProperty, ProductPropertyModal, SizeFlyoverContent }
}

})